const page7 = {
  id: 7,
  title: "Троицкая Церковь",
  location: "посёлок Гусь-Железный, Рязанская область",
  years: "Годы постройки: 1802–1825, 1847–1868",
  text: "Храм в нетипичном для России стиле псевдоготики заменил деревянную церковь, которая сгорела в 1802 году. Строительство начал сын крупного промышленника Андрей Андреевич Баташёв на территории родовой усадьбы.<br/><br/>Собор был долгостроем: к 1825 году его возвели до купола, а затем приостановили работы. Возобновили их лишь в 1847 году.<br/><br/>До прихода советской власти в храме хранились ценные иконы и святыни. Реликвии изъяли, а само здание стали использовать как склад. В 1948 году собор вернули Русской Православной церкви, но к тому моменту он пришёл в запустение.",
  info: {
    stateTitle: "Что с храмом сейчас",
    stateText: "В 1974 году храм стал памятником федерального значения, однако на его состоянии это не отразилось. В 1990 году здание передали верующим посёлка, которые восстанавливали его своими силами. Хотя в нижней части церкви до сих пор идут службы, сооружение остаётся аварийным. На крыше гниют деревянные конструкции, кирпич разрушается, сверху падают камни, а звонари боятся подниматься на колокольню.",
  },
  image: "troick",
  author: "Вадим Разумов",
  authorDescription: ', автор блога «Летопись русской усадьбы»',
  authorLink: "https://ok.ru/profile/640048346",
  video: "//ok.ru/videoembed/6576918301243",
  comment: {
    author: "Пётр Шутов",
    photo: "peter.jpg",
    text: "Будто бы обломок пикника на обочине, громадная Троицкая церковь поражает своей неуместностью на краю тихого посёлка. Пустые места в её истории только добавляют вопросов. И казалось бы — столичный масштаб, но если бы она оказалась в одной из столиц, вопросов стало бы не меньше — своим обликом она олицетворяет некую иную ветвь развития архитектуры. Белый камень намекает на домонгольское строительство, стрельчатые окна и пинакли на западную готику, выделенные колоннами углы, поднятые фронтоны купола на барокко, при этом все эти отсылки не прямые, каждая требует своего «но», отчего здание зависает вне эпох и канонов. Удивительная штука заслуживающая большего внимания, чем полуживой храм на обочине дороги."
  },
  slider: ["troick/1.png"],
  color: "#7EC7E9",
  textColor: "#A4A3F6",
  helpLink: "https://fondvnimanie.ru/",
  coordinates: [4.7, 2.13]
}

export { page7 };
